import { Box, Text, Select, ResponsiveContext } from 'grommet';
import { FunctionComponent, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Criterion } from '../../../../corelogic/entities/criterion.interface';

type RatingCriteriaProps = {
  criterion: Criterion;
  register: any;
};

const RatingCriteria: FunctionComponent<RatingCriteriaProps> = ({
  criterion,
  register,
}) => {
  const [rate, setRate] = useState<number | undefined>();
  const { t, i18n } = useTranslation();
  const size = useContext(ResponsiveContext);

  useEffect(() => {
    register(criterion.id.toString(), {
      required: true,
      min: 1,
      max: 10,
      pattern: {
        value: /^([1-9]|10)$/,
        message: t('rating.form.error'),
      },
    });
  }, [criterion.id, register, t]);

  return (
    <Box
      direction={size === 'small' ? 'column' : 'row'}
      gap="small"
      align="center"
      justify="between"
      pad={{ vertical: 'xsmall' }}
    >
      {/* Criterion Label */}
      <Box flex basis={size === 'small' ? 'auto' : '40%'}>
        <Text wordBreak="break-word">
          {i18n.language === 'en'
            ? criterion.criteriaEn ?? t('rating.criterion')
            : criterion.criteriaFr ?? t('rating.criterion')}
        </Text>
      </Box>

      {/* Select */}
      <Box flex basis="60%">
        <Select
          name={criterion.id.toString()}
          options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          value={rate}
          onChange={({ option }) => setRate(option)}
          placeholder={t('rating.label')}
        />
      </Box>
    </Box>
  );
};

export default RatingCriteria;
